import { useSearchParams } from "react-router-dom";
import CharityService from "../../../services/CharityService";
import { Charity } from "../../../models";
import { useEffect, useState } from "react";
import { CreateCharity } from "./ui/buttons";
import CharitiesTable from "./ui/charities-table";
import CharitiesSkeleton from "./skeleton/charities-skeleton";
import Breadcrumbs from "../../../components/breadcrumbs";

export default function CharitiesPage() {
    const [searchParams] = useSearchParams();
       const api = new CharityService();
       const [charities,setCharities] = useState<Charity[]>([]);
       const [loading, setLoading] = useState(true);

       useEffect(() => {     
         fetchCharities();
       }, [searchParams.get("reload")]);
       
       const fetchCharities = async () => {
         const data = await api.getCharities();
         setCharities(data);
         setLoading(false);     
       };
        
     return (
       <div className="w-full">
          <Breadcrumbs
                    breadcrumbs={[
                      { label: "Charities", href: "/admin/charities" }
                     
                    ]}
                  />         
         <CreateCharity />
         {loading ? <CharitiesSkeleton /> : <CharitiesTable charities={charities} />}
       </div>
     );
   
}
